import {Link} from 'react-router-dom'
import {AiFillStar} from 'react-icons/ai'
import {MdLocationOn} from 'react-icons/md'
import {BsBriefcaseFill} from 'react-icons/bs'
import './index.css'

const JobsCard = props => {
  const {jobDetails} = props
  const {
    companyLogo,
    employmentType,
    id,
    jobDescription,
    location,
    packagePerAnnum,
    rating,
    title,
  } = jobDetails
  return (
    <Link to={`/jobs/${id}`} className="link-element">
      <li className="jobs-card-list">
        <div className="job-card-container">
          <div className="job-logo-container">
            <img
              className="company-logo"
              src={companyLogo}
              alt="company logo"
            />
            <div className="company-name-container">
              <h1 className="title-text">{title}</h1>
              <div className="star-container">
                <AiFillStar className="start-icon" />
                <p className="rating-text">{rating}</p>
              </div>
            </div>
          </div>
          <div className="middle-container">
            <div className="location-and-type-container">
              <div className="location-container">
                <MdLocationOn className="location-icon" />
                <p className="location-text">{location}</p>
              </div>
              <div className="location-container">
                <BsBriefcaseFill className="location-icon" />
                <p className="location-text">{employmentType}</p>
              </div>
            </div>
            <p className="package-text">{packagePerAnnum}</p>
          </div>
          <hr className="line-job" />
          <h1 className="job-description-title">Description</h1>
          <p className="descrition-text">{jobDescription}</p>
        </div>
      </li>
    </Link>
  )
}

export default JobsCard
